import { PostoService } from '../../../base/services/posto.service';
import { PostoSelectDTO } from '../../../base/domain/dto/posto-select.dto';
import { EstadoSelectDTO } from '../../../base/domain/dto/estado-select.dto';
import { EstadoService } from 'src/app/base/services/estado.service';
import { LazyLoadEvent } from 'primeng/api';
import { QueryOptions } from '../../domain/query.options';
import { Page } from '../../../base/domain/return-api.model';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { RotaService } from 'src/app/base/services/rota.service';
import { Rota } from 'src/app/base/domain/rota.model';
import { ConciliacaoBancariaDoc } from '../../../base/domain/conciliacao-bancaria-doc.model';

export interface VisualizarConciliacaoBancariaDocFilterOptions {
  dataInicial: Date;

  dataFinal: Date;

  estadoId: number;

  postoUID: string;

  processado: boolean;

  rotaId: number;
}

export interface ConciliacaoBancariaDocEvent {
  acao: string;
  conciliacao: ConciliacaoBancariaDoc;
}

@Component({
  selector: 'app-visualizar-conciliacao-doc-list',
  templateUrl: './visualizar-conciliacao-doc-list.component.html',
  styleUrls: ['./visualizar-conciliacao-doc-list.component.css'],
})
export class VisualizarConciliacaoDocListComponent implements OnInit {
  @Output() filter = new EventEmitter<VisualizarConciliacaoBancariaDocFilterOptions>();
  @Output() loadArquivosPage = new EventEmitter<number>();
  @Output() acaoClick = new EventEmitter<ConciliacaoBancariaDocEvent>();
  @Output() menuAcaoClick = new EventEmitter<string>();
  @Output() novo = new EventEmitter<void>();

  filterOptions: VisualizarConciliacaoBancariaDocFilterOptions;
  private readonly defaultFilterOptions: VisualizarConciliacaoBancariaDocFilterOptions = {
    dataInicial: null,
    dataFinal: null,
    estadoId: null,
    postoUID: null,
    processado: false,
    rotaId: null,
  };

  @Input() page: Page<ConciliacaoBancariaDoc>;
  @Input() totalRecords: number;
  @Input() rowsNumber: number;
  @Input() loading: boolean;
  @Input() valorTotal: number;

  private currentPage = 0;
  queryOptions = new QueryOptions();

  public estados: EstadoSelectDTO[];
  public postos: PostoSelectDTO[];
  public rotas: Rota[];
  estadoId: number;

  constructor() {}

  ngOnInit(): void {
    this.onLimparFiltros();
  }

  loadArquivos(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber - 1;
    this.loadArquivosPage.emit(pageNumber);
  }

  onAtualizar(): void {
    this.loadArquivosPage.emit(this.currentPage);
  }

  onMenuAcaoClick(event: string): void {
    this.menuAcaoClick.emit(event);
  }

  onAcaoClick(acao: string, domain: ConciliacaoBancariaDoc): void {
    this.acaoClick.emit({ acao, conciliacao: domain });
  }

  onLimparFiltros(): void {
    this.filterOptions = Object.assign({}, this.defaultFilterOptions);
  }

  onAplicarFiltro(): void {
    this.filter.emit(this.filterOptions);
  }

  onNovo(): void {
    this.novo.emit();
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
}
